import { render, staticRenderFns } from "./MitAdminPage.vue?vue&type=template&id=2a6abe11&scoped=true"
import script from "./MitAdminPage.vue?vue&type=script&lang=js"
export * from "./MitAdminPage.vue?vue&type=script&lang=js"
import style0 from "./MitAdminPage.vue?vue&type=style&index=0&id=2a6abe11&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a6abe11",
  null
  
)

export default component.exports